// @flow

import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import { reducer as formReducer } from "redux-form";
import * as router from "./router/routerReducer";
import user from "./user/reducer";


export type State = {
  user: any,
  company: any
}

export type Action = (dispatch: Dispatch<*>, getState: () => State) => { type: string };

export default combineReducers({
  routing: routerReducer,
  form:    formReducer,
  user,
  router: router.routerReducer,
});



// WEBPACK FOOTER //
// ./src/ducks/reducers.js